import React from 'react'
import colors from '../../../helpers/assessment/colors';

export default function ScoreChart ({name, bySubtest}) {
  const scale = bySubtest.scale
  const fill = Math.round(bySubtest.scale * 1000 / 36) / 10
  const remain = 100 - fill
  const lowerName = name.toLowerCase()
  const circleColors = colors.scoreChart[lowerName]
  return (
    <div className="score-chart">
      <div className="donut-chart subject">
        <svg width="100%" height="100%" viewBox="0 0 42 42" className="donut">
          <defs>
            <radialGradient id={`${lowerName}-radial`} fx="50%" fy="50%" cx="75%" cy="75%" r="100%">
              <stop offset="0%" stopColor={circleColors[0]} stopOpacity="1" />
              <stop offset="20%" stopColor={circleColors[1]} stopOpacity="1" />
            </radialGradient>
          </defs>

          <circle 
            className="donut-ring" 
            cx="21" cy="21" r="15.91549430918954" 
            fill="transparent" stroke="#d2d3d4" 
            strokeWidth="5">
          </circle>

          <circle 
            className="donut-segment" 
            cx="21" cy="21" r="15.91549430918954" 
            fill="transparent" stroke={`url(#${lowerName}-radial)`}
            strokeWidth="5" strokeDasharray={`${fill} ${remain}`} 
            strokeDashoffset="25">
          </circle>

          <circle 
            className="donut-shadow" 
            cx="21" cy="21" r="14" 
            fill="transparent" stroke="rgba(0,0,0,0.08)" 
            strokeWidth="1">
          </circle>

        </svg>
        <div className="chart-text">
          <p className="chart-number">
            {Math.round(scale * 10) / 10}
          </p>
          <p className="chart-label">
            {name}
          </p>
        </div>

      </div>
    </div>
  )
}


// WEBPACK FOOTER //
// ./src/components/Assessment/AssessPrint/ScoreChart.js